module.exports = __webpack_public_path__ + "static/img/icon7.3f9e1635.svg";